import React, { Suspense, useContext } from 'react';

import PhysicalKPIs from 'components/data-containers/KPIs/Physical/PhysicalKPIs';
import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';
import PerformanceTrendSkeleton from 'components/data-containers/PerformanceTrend/SkeletonLoader';
import PerformanceBreakdownLoader from 'components/data-containers/PerformanceBreakdown/SkeletonLoader';
import { EntityContext } from 'context/entityContext';

const PhysicalPerformanceTrend = React.lazy(() => {
  return import(
    'components/data-containers/PerformanceTrend/PhysicalPerformanceTrend'
  );
});

const PhysicalPerformanceBreakdown = React.lazy(() =>
  import(
    'components/data-containers/PerformanceBreakdown/PhysicalPerformanceBreakdown'
  )
);

const Physical: React.FC = () => {
  const ctx = useContext(EntityContext);
  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      <PhysicalKPIs
        allowedFilters={['country', 'region', 'customRegion']}
        {...ctx}
      />

      <Suspense
        fallback={
          <PerformanceTrendSkeleton
            title="Physical Performance"
            dropdownLabel="All Configurations"
            toggleOptions={[
              { value: 'aggregate', label: 'All Configurations', active: true },
              { value: 'all', label: 'By Configuration', active: false },
            ]}
            showPeriodDropdown
          />
        }
      >
        <PhysicalPerformanceTrend />
      </Suspense>

      <Suspense fallback={<PerformanceBreakdownLoader barCount={5} />}>
        <PhysicalPerformanceBreakdown />
      </Suspense>

      <Layout.MaxWidth>
        <Message>
          Data on this page is related to release sales only and does not
          include track data.
        </Message>
      </Layout.MaxWidth>
    </div>
  );
};

export default Physical;
